import type { DonutTone } from "@/types";

export const getColor = (score: number): DonutTone => {
  if (score === 0 || !score) {
    return "unknown";
  }
  if (score < 4) {
    return "negative";
  }
  if (score < 7) {
    return "mediocre";
  }
  return "positive";
};
